/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_payment_links_detail_tab_embed = /** @type {(inputs: {}) => string} */ () => {
	return `Incrustar`
};

const en_payment_links_detail_tab_embed = /** @type {(inputs: {}) => string} */ () => {
	return `Embed`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const payment_links_detail_tab_embed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.payment_links_detail_tab_embed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("payment_links_detail_tab_embed", locale)
	if (locale === "es") return es_payment_links_detail_tab_embed(inputs)
	return en_payment_links_detail_tab_embed(inputs)
};
export { payment_links_detail_tab_embed as "payment_links.detail.tab_embed" }